export function getAll() {
  return [
    {
      value: 0,
      name: "Created",
      text: "建立",
    },
    {
      value: 1,
      name: "Started",
      text: "開始",
    },
    {
      value: 2,
      name: "Checked",
      text: "點收",
    },
    {
      value: 3,
      name: "Completed",
      text: "完成",
    },
  ];
}

export function getByValue(value) {
  return getAll().find((item) => item.value == value);
}
